import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('permissions/get/permitted', 'permitted');

tbl.add(new Xtc('id', 'code'))
tbl.add(new Xtc('title', 'title'))
tbl.add(new Xtc('created_at', 'created at'))
tbl.add(new Xtc('actions', 'actions').renderSlot('act'))

export default tbl;

